module.exports = __webpack_public_path__ + "static/media/view1.2bcc64f3.jpg";